export function TextInput({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  suffix,
  error,
  testId,
  min,
  max,
  step,
  disabled = false,
}) {
  return (
    <div style={{ position: "relative", marginBottom: 22 }}>
      <label className="block text-xs font-semibold text-we-text mb-1.5">
        {label}
      </label>
      <div className="relative">
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          min={min}
          max={max}
          step={step}
          data-testid={testId}
          className={`we-input ${suffix ? "pr-12" : ""} ${error ? "we-input-error" : ""} ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        />
        {suffix && (
          <span className="absolute right-3.5 top-1/2 -translate-y-1/2 text-xs text-we-text-2 font-medium pointer-events-none">
            {suffix}
          </span>
        )}
      </div>
      {error && (
        <p
          data-testid={`${testId}-error`}
          style={{
            position: "absolute",
            bottom: -14,
            left: 4,
            fontSize: 11,
            lineHeight: 1,
            color: "#C0453A",
            fontWeight: 500,
            zIndex: 1,
            pointerEvents: "none",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "calc(100% - 8px)",
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
}
